import React from 'react';
import { Box, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from '../../lib/index';
import background from '../../assets/images/VisionBG.png';

function ShopifyBuyInit(shopifyId) {
  // eslint-disable-next-line no-undef
  const client = ShopifyBuy.buildClient({
    domain: 'humandesignclub.myshopify.com',
    storefrontAccessToken: '7baca2730b03321f5d02cbcf5daaa2b8',
  }); // eslint-disable-next-line no-undef
  ShopifyBuy.UI.onReady(client).then((ui) => {
    ui.createComponent('product', {
      id: shopifyId,
      node: document.getElementById(
        'product-component-hdc-readersdirectory-buy-reading-ip'
      ),
      moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
      options: {
        product: {
          iframe: false,
          buttonDestination: 'checkout',
          layout: 'horizontal',
          styles: {},
          contents: {
            img: false,
            title: false,
            price: false,
          },
          text: {
            button: 'Reading buchen',
          },
          googleFonts: ['Poppins'],
        },
        productSet: {
          styles: {},
        },
        option: {},
        cart: {
          styles: {},
          text: {
            total: 'Subtotal',
            button: 'Checkout',
          },
          popup: true,
          googleFonts: ['Open Sans'],
        },
      },
    });
  });
}

function loadScript(scriptURL, shopifyId) {
  const script = document.createElement('script');
  script.async = true;
  script.src = scriptURL;
  (
    document.getElementsByTagName('head')[0]
    || document.getElementsByTagName('body')[0]
  ).appendChild(script);
  script.onload = () => ShopifyBuyInit(shopifyId);
}

function buybutton(shopifyId) {
  const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
  if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      ShopifyBuyInit(shopifyId);
    } else {
      loadScript(scriptURL, shopifyId);
    }
  } else {
    loadScript(scriptURL, shopifyId);
  }
}

function BuyButton({ shopifyId }) {
  buybutton(shopifyId);
  return (
    <BuyButtonContainer>
      <Box className="cta-box">
        <Typography>Reading wählen </Typography>
        <Typography>und direkt buchen</Typography>
      </Box>
      <Box className="button-wrapper">
        <div id="product-component-hdc-readersdirectory-buy-reading-ip" />
      </Box>
    </BuyButtonContainer>
  );
}

export default BuyButton;

const BuyButtonContainer = styled(
  Box,
  {}
)({
  display: 'flex',
  marginTop: 50,
  width: '100%',
  height: 250,
  overflow: 'hidden',
  borderRadius: '0 30px 0 30px',

  flexDirection: 'column',

  [theme.breakpoints.up('laptop')]: {
    marginTop: 0,
    height: 100,

    flexDirection: 'row',
  },

  '& .cta-box': {
    height: 60,

    background: theme.palette.newPrimary,

    textAlign: 'center',

    [theme.breakpoints.up('laptop')]: {
      display: 'flex',
      minWidth: 250,
      height: '100%',

      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },

    '& .MuiTypography-root': {
      ...theme.typography.p16,

      display: 'inline',

      textAlign: 'center',
      lineHeight: '60px',

      [theme.breakpoints.up('laptop')]: {
        display: 'block',

        lineHeight: 'inherit',
      },
    },
  },

  '& .button-wrapper': {
    position: 'relative',
    width: '100%',
    flexGrow: 1,

    '&:before': {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,

      background: `url(${background}), ${theme.palette.lightgrey}`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right',
      backgroundSize: 'cover',
      backgroundBlendMode: 'multiply',

      filter: 'saturate(0)',
      content: "''",
    },

    '& #product-component-hdc-readersdirectory-buy-reading-ip': {

      '& .shopify-buy__product': {
        display: 'none',
      },

      '& .shopify-buy__product:nth-of-type(1)': {
        display: 'flex',
        width: '100%',
        height: '190px',

        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,

        [theme.breakpoints.up('laptop')]: {
          height: '100px',

          flexDirection: 'row',
          justifyContent: 'space-evenly',
        },

        '& .shopify-buy__option-select': {
          [theme.breakpoints.up('tablet')]: {
            marginRight: 30,
          },
          [theme.breakpoints.up('laptop')]: {
            marginRight: 0,
          },
          '&__label': {
            display: 'none',
          },

          '&-wrapper': {
            position: 'relative',
            width: 255,
            margin: '0 20px',
            borderRadius: 15,

            background: `${theme.palette.backgroundgrey}`,

            transition:
            'box-shadow 250ms ease-in-out, transform 250ms ease-in-out, background 250ms ease-in-out',

            [theme.breakpoints.up('tablet')]: {
              width: '95%',
            },

            '&:hover': {
              background: `${theme.palette.white}`,
              boxShadow: `3px 3px 10px ${theme.palette.lightgrey}`,

              transform: 'scale(1.01)',

              transition:
                'box-shadow 250ms ease-in-out, transform 250ms ease-in-out, background 250ms ease-in-out',

              cursor: 'pointer',
            },
          },

          '& .shopify-buy__select-icon': {
            position: 'absolute',
            top: '50%',
            right: 20,
            zIndex: 1,

            width: 17,

            transform: 'translate(0,-50%)',

            [theme.breakpoints.up('laptop')]: {
              right: 30,
            },
          },

          '&__select': {
            position: 'relative',
            ...theme.typography.pBold,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            zIndex: 2,

            padding: '20px 40px 20px 20px',
            width: '100%',
            borderRadius: 15,

            background: 'transparent',

            appearance: 'none',

            [theme.breakpoints.up('tablet')]: {
              width: '100%',
            },

            [theme.breakpoints.up('laptop')]: {
              ...theme.typography.pBold17,

              padding: '20px 100px 20px 30px',
              width: '100%',
            },

            '&:hover': {
              cursor: 'pointer',
            },

            '&:focus-visible': {
              outlineColor: theme.palette.newPrimary,
            },
          },
        },

        '& .shopify-buy__btn': {
          ...theme.typography.pBold17,

          position: 'relative',

          padding: '17px 27px 17px 27px',
          width: 255,
          borderRadius: 15,

          background: theme.palette.newPrimary,
          border: 'none',

          boxShadow: `${theme.palette.newPrimaryShadow} 2px 2px 0`,

          transition:
            'box-shadow 250ms ease-in-out, transform 250ms ease-in-out, background 250ms ease-in-out',

          [theme.breakpoints.up('laptop')]: {
            marginRight: 20,
            width: 'unset',
          },

          '&:hover': {
            background: theme.palette.newSecondary,
            boxShadow: `3px 3px 10px ${theme.palette.lightgrey}`,

            transform: 'scale(1.01)',

            transition:
              'box-shadow 250ms ease-in-out, transform 250ms ease-in-out, background 250ms ease-in-out',

            cursor: 'pointer',
          },
        },
      },
    },

    '&__image': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,

      width: 820,
      opacity: 0.3,

      filter: 'saturate(0) contrast(1.5)',
      mixBlendMode: 'multiply',
    },
  },

});
